import { checkoutReviewAndSubmitPaymentDetailsStyles as styles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import { css } from "styled-components";

styles.creditCardDetailsGridItem = {
    ...styles.creditCardDetailsGridItem,
    css: css`
        /* stylelint-disable */
        #paymetricIframe {
            border: none;
        }
        /* stylelint-enable */
    `,
};
